import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import LogoTitle from '../../assets/images/logo-s.png'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders';
import Logo from './Logo'
import './index.scss'

const Home = () => {

  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = 'ev Badodiya'.split('')
  const jobArray = 'Entrepreneur'.split('')
  const interestArray = 'Full Stack Developer'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
    return () => clearTimeout(timer)
  }, [])
  

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
          
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>
            <img
              src={LogoTitle} alt="Developer"
            />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
              />
              <br />
              <AnimatedLetters
                letterClass={letterClass}
                strArray={interestArray}
                idx={22}
              />
          </h1>
          <h2>Full Stack Developer / Entrepreneur / Engineer</h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <Logo />
      </div>
      <Loader type="pacman" />
      </>
  ) 
  
  }    

export default Home
